import React, { isValidElement, useContext, useEffect, useLayoutEffect, useState } from 'react'
import { Button, FormControl, IconButton, Input, InputAdornment, InputLabel, Tooltip, Zoom } from '@mui/material'
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import ContactSupportTwoToneIcon from '@mui/icons-material/ContactSupportTwoTone';
import AccountCircle from '@mui/icons-material/AccountCircle'
import PasswordIcon from '@mui/icons-material/Password';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import { Form, useNavigate } from 'react-router-dom';
import LoginContext from '../../context/login_context/LoginContext';
import { VERSION_APP } from '../../router/Url';

export const Login = () => {
  
  const navigate = useNavigate();

  const {LoginState,SetLogin,CloseLogin,GetLoginSession} = useContext(LoginContext);
  const [IsValidate, setIsValidate] = useState(true)
  

  useLayoutEffect(() => {
    // if(LoginState.token!=='NO-TOKEN')navigate('/dashboard')
  }, [LoginState])
  

  const [valores, setValores] = useState({
    user:'',
    password:'',
    showPassword: false,
    isSubmit: false,
    errorMessage: null
  })

  const HandleSetData = async (e) => {
    let a = e.target.value.trim()
    let d = a.split('-').join('')
    // console.log(d)
    if(d.length<=9){
      let b = d.slice(d.length-1)
      let c = d.slice(0,d.length-1)
      // console.log(d.length,c,"-",b)
      setValores({...valores,[e.target.name]:c+"-"+b});
    }

    if(d.length>=8){
      setIsValidate(false)
    }else{
      setIsValidate(true)
    }
  }

  // show or hide pass input
  const handleClickShowPassword = () => {
    setValores({
      ...valores,
      showPassword: !valores.showPassword,
    });
  };
  
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  // verify login
  const HandleSubmit = async (e) => {
    e.preventDefault();
    const isLogin = await SetLogin({valores})
    // console.log(isLogin)
    if(isLogin.success){
      navigate('./ot')//ingresar_transporte
    }else{
      setValores({...valores,errorMessage:isLogin.error})
    }
  }

  useEffect(() => {
    if(valores.user.length >= 8){
      setIsValidate(false)
    }else{
      setIsValidate(true)
    }
  }, [valores])
  
  return (
    <>
      <div className="container-fluid bg-ariztia">
        <div className="row" style={{height: '100vh'}}>
          <div className="col-12 col-md-6 d-flex align-items-center text-center justify-content-center">
            <img src="/img/logo_ariztia.png" alt="Ariztia" />
          </div>
          <div className="col-12 col-md-5 px-3 fondo d-flex align-items-center text-center justify-content-center performance-2-2" >
            <div className="row">
              <div className="col-12 pt-3 text-left">
                <h4>Iniciar Sesión.</h4>
              </div>
              <form onSubmit={(e)=>HandleSubmit(e)}>
                <div className="col-12 pt-3">
                  <FormControl fullWidth variant="standard">
                    <InputLabel htmlFor="input-username">
                      Rut o Correo
                    </InputLabel>
                    <Input
                      placeholder='Ingrese su Rut o Correo'
                      type="text"
                      name='user'
                      value={valores.user}
                      onChange={(e)=>setValores({...valores,[e.target.name]:e.target.value})}
                      startAdornment={
                        <InputAdornment position="start">
                          <AccountCircle />
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                  <small style={{color: '#9B9C9C'}}><b>Rut:</b> si termina en k ingresela con <b>Mayusculas EJ: 12345678-K</b></small>
                    <br/>
                  <small style={{color: '#9B9C9C'}}><b>Correo:</b> Con minusculas</small>
                </div>
                <div className="col-12 pt-3">
                
                </div>
                <div className="col-12">
                  {valores.errorMessage?
                  <small className="text-danger">{valores.errorMessage}</small>
                  :null
                  }
                </div>
                <div className="col-12 pt-5 text-right">
                  <Button
                    disabled={IsValidate}
                    fullWidth
                    variant="contained"
                    size="small"
                    type='submit'
                    endIcon={<AssignmentIndIcon />} >Entrar</Button>
                </div>
              </form>
              <div className='col-12 alfondo'>
                <div className='row'>
                  <div className='col text-right'>
                  {/* <span className='version_lg'>{VERSION_APP}</span> */}
                    <img
                      src={`https://readme-typing-svg.herokuapp.com?font=Arrial&size=15&pause=1000&color=FF0000&width=435&lines=${VERSION_APP}`}
                      alt="Typing SVG"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
